import { render, staticRenderFns } from "./MioCovidObservations.vue?vue&type=template&id=2d755c6e&"
import script from "./MioCovidObservations.vue?vue&type=script&lang=js&"
export * from "./MioCovidObservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports